import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ExportDataPanel from '../components/ExportDataPanel';

export default function ExportDataPage() {
  return (
    <DashboardLayout>
      <ExportDataPanel />
    </DashboardLayout>
  );
}
